// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2en1H","title":"Images90_title__1-v_l","images":"Images90_images__2zikW"};